import * as React from 'react';
import * as Redux from 'redux';
import * as ReactRedux from 'react-redux';
import { IndicatorDataSave } from './indicator-data-save';
import { IConfigState, IResultState, IState, IUIState, IUploadState } from '../../../interfaces';

export interface IIndicatorDataSaveStateProps {
  readonly ui: IUIState;
  readonly upload: IUploadState;
  readonly config: IConfigState;
  readonly result: IResultState;
}

export type IIndicatorDataSaveConnectProps = IIndicatorDataSaveStateProps
  & ReactRedux.DispatchProp<Redux.Action>;

export function mapStateToProps(state: IState): IIndicatorDataSaveStateProps {
  return {
    ui: state.ui,
    upload: state.upload,
    config: state.config,
    result: state.result
  };
}

export const IndicatorDataSaveContainer: React.ComponentClass
  = ReactRedux.connect(mapStateToProps)(IndicatorDataSave);
